import React, { useEffect } from "react";
import { makeStyles, Text, tokens, Button, Image } from "@fluentui/react-components";
import { useIntl } from "react-intl";

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: tokens.spacingHorizontalXXL,
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
  }
})

export const AppListEmpty: React.FC<{ setNewDialogOpen: (open: boolean) => void }> = ({ setNewDialogOpen }) => {
  const classes = useStyles();
  const intl = useIntl();
  return (<div className={classes.container}>
    <Image
      src="/images/svg/app-features-empty.svg"
      alt={intl.formatMessage({ defaultMessage: 'Empty state icon', description: 'Icon for empty state' })}
      width={200} height={200}
    />
    <Button onClick={() => setNewDialogOpen(true)} appearance="primary">
      {intl.formatMessage({ defaultMessage: 'Create your first app', description: 'Button text to create a new app' })}
    </Button>
  </div>)
};